import { lazyLoad } from 'utils/loadable';

export const DocumentationPage = lazyLoad(
  () => import('app/components/pages/DocumentationPage/index'),
  (module) => module.DocumentationPage,
);
